import groq from 'groq'

import { blogSettingsFragment } from './blog'
import { contentFragment } from './content'
import { imageFragment } from './image'
import { linkFragment, linkPageFragment } from './link'

const headerDesktopMenuFragment = groq`
  "slug": slug.current,
  items[] {
    ${linkFragment},
    dropdownItems[] {
      ${linkFragment}
    },
  }
`

const headerMobileMenuFragment = groq`
  "slug": slug.current,
  items[] {
    ${linkFragment},
    dropdownItems[] {
      ${linkFragment}
    }
  }
`

const headerPromoFragment = groq`
  enabled,
  display,
  text,
  "link": link->{
    ${linkPageFragment}
  },
`

const headerFragment = groq`
  menuDesktopLeft->{
    ${headerDesktopMenuFragment}
  },
  menuDesktopRight->{
    ${headerDesktopMenuFragment}
  },
  menuMobilePrimary->{
    ${headerMobileMenuFragment}
  },
  menuMobileSecondary->{
    ${headerMobileMenuFragment}
  },
  "promo": *[_type == "promoSettings" && locale == $locale][0] {
    ${headerPromoFragment}
  },
`

const footerMenuFragment = groq`
  "slug": slug.current,
  items[] {
    ${linkFragment}
  }
`

const footerFragment = groq`
  "blocks": [
    {
      "title": blockTitle1,
      "description": blockDescription1[] {
        ${contentFragment}
      },
    },
    {
      "title": blockTitle2,
      "description": blockDescription2[] {
        ${contentFragment}
      },
    },
    {
      "title": blockTitle3v2,
      "description": blockDescription3v2[] {
        ${contentFragment}
      },
      "menu": blockMenu3->{
        ${footerMenuFragment}
      },
    },
    {
      "title": blockTitle4v2,
      "description": blockDescription4v2[] {
        ${contentFragment}
      },
      social[] {
        _key,
        name,
        url
      },
    }
  ],
  copyright,
`

const cookieConsentFragment = groq`
  enabled,
  message,
  "link": link->{
    ${linkPageFragment}
  },
`

const seoFragment = groq`
  siteTitle,
  metaTitle,
  metaDesc,
  shareTitle,
  shareDesc,
  shareGraphic,
`

const siteStringsFragment = groq`
  loadingPageTitle,
  languageSwitch,
  skipToContent,
  goHomeLabel,
  mobileMenuLabel,
  carouselCounterText,
  carouselLeftArrowLabel,
  carouselRightArrowLabel,
  carouselDotLabel,
  buttonAccept,
  buttonLearnMore,
  buttonTryAgain,
  buttonLoadMore,
  buttonAllFilter,
  emailAddress,
  emailAddressPlaceholder,
  emailMissing,
  emailInvalid,
  firstName,
  firstNamePlaceholder,
  firstNameMissing,
  lastName,
  lastNamePlaceholder,
  lastNameMissing,
  fullName,
  fullNamePlaceholder,
  fullNameMissing,
  phoneNumber,
  phoneNumberPlaceholder,
  phoneNumberMissing,
  phoneNumberInvalid,
  company,
  companyPlaceholder,
`

const identityFragment = groq`
  logo {
    ${imageFragment}
  },
  invertedLogo {
    ${imageFragment}
  },
`

const publicSettingsFragment = groq`
  public,
  siteURL,
  hubSpotPortalId,
  klaviyoAccountID,
  gtmScriptUrl,
  pageAnimation,
`

const allSettingsFragment = groq`
  hubSpotAccessToken,
  klaviyoPrivateKey,
  ${publicSettingsFragment}
`

export const publicSiteSettingsQuery = groq`
*[_type == "generalSettings" && locale == $locale][0] {
  ${publicSettingsFragment}
}
`

export const allSiteSettingsQuery = groq`
  *[_type == "generalSettings" && locale == $locale][0] {
    ${allSettingsFragment}
  }
`

export const siteFragment = groq`
  "publicLocales": *[_type == "generalSettings" && public == true][].locale,
  "settings": *[_type == "generalSettings" && locale == $locale][0] {
    ${publicSettingsFragment}
  },
  "identity": *[_type == "identitySettings" && locale == $locale][0] {
    ${identityFragment}
  },
  "blogSettings": *[_type == "blogSettings" && locale == $locale][0] {
    ${blogSettingsFragment}
  },
  "cookieConsent": *[_type == "cookieSettings" && locale == $locale][0] {
    ${cookieConsentFragment}
  },
  "header": *[_type == "headerSettings" && locale == $locale][0] {
    ${headerFragment}
  },
  "footer": *[_type == "footerSettings" && locale == $locale][0] {
    ${footerFragment}
  },
  "seo": *[_type == "seoSettings" && locale == $locale][0] {
    ${seoFragment}
  },
  "siteStrings": *[_type == "strings" && locale == $locale][0] {
    ${siteStringsFragment}
  },
`

export const siteQuery = groq`
  ${siteFragment}
`

export const allPublicSiteSettingsQuery = groq`
  *[
    _type == "generalSettings"
  ] {
    locale,
    ${publicSettingsFragment}
  }
`
